import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Loader2, FileText, Download } from "lucide-react";
import { api, fileUrl } from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { catLabel } from "@/lib/essap";

export default function EssapPostPage() {
  const { id } = useParams();
  const [p, setP] = useState(undefined);
  useEffect(() => { api.get(`/essap/posts/${id}`).then((r) => setP(r.data)).catch(() => setP(null)); }, [id]);

  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 py-12 lg:py-16">
      {p === undefined && <Loader2 className="h-8 w-8 animate-spin text-emerald-700" />}
      {p === null && <p data-testid="essap-post-not-found" className="text-slate-500">Cette publication est introuvable.</p>}
      {p && (
        <div className="rise space-y-6">
          <Link to={`/essap/${p.categorie}`} data-testid="essap-post-back" className="inline-flex items-center gap-1 text-sm font-semibold text-emerald-800 hover:gap-2 transition-[gap]"><ArrowLeft className="h-4 w-4" /> {catLabel(p.categorie)}</Link>
          <div className="text-xs uppercase tracking-[0.14em] text-emerald-700 font-semibold">{fmtDate(p.created_at)}</div>
          <h1 data-testid="essap-post-title" className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900 leading-tight">{p.titre}</h1>
          {p.image && <img src={fileUrl(p.image)} alt={p.titre} className="w-full rounded-2xl object-cover max-h-[460px]" />}
          {p.contenu && <div data-testid="essap-post-content" className="text-slate-700 leading-relaxed whitespace-pre-line">{p.contenu}</div>}
          {p.fichier && (
            <a href={fileUrl(p.fichier)} target="_blank" rel="noreferrer" data-testid="essap-post-file" className="flex items-center gap-4 rounded-2xl border border-emerald-900/10 bg-white p-4 hover:shadow-md transition-shadow">
              <FileText className="h-8 w-8 text-rose-600 shrink-0" />
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-slate-900 truncate">{p.fichier_nom || "Document PDF"}</div>
                <div className="text-xs text-slate-500">Ouvrir ou télécharger le document</div>
              </div>
              <Download className="h-5 w-5 text-emerald-700" />
            </a>
          )}
        </div>
      )}
    </article>
  );
}
